import { useCallback, useState } from "react";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import { SvgMiscDownload } from "@ugitgud/legos/ui/icon/SVG/MiscDownload";
import classNames from "classnames";
import { BannerProps } from "./BannerContainer";

export const ARAM_MAYHEM_BANNER_CTA = "aram-mayhem-app-banner-cta";

const BANNER_ART = "https://static.bigbrain.gg/assets/ugg/cta/aram-mayhem-banner.png";

export function AramMayhemBanner(props: BannerProps) {
  const { url, onClick, onClose, utmSource } = props;
  const [open, setOpen] = useState(true);

  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onClose?.();
    }, 150);
  }, [onClose]);

  return (
    <div
      className={classNames("transition-all relative px-[12px] w-full overflow-hidden bg-purple-550", open ? "h-[48px]" : "h-0")}
    >
      <div
        className="absolute inset-0 bg-no-repeat bg-[position:25%_center] max-lg:bg-[position:28.9%_center] max-md:bg-[position:37.5%_center] max-sm:bg-[position:48%_center] max-xs:bg-[position:49.5%_center]"
        style={{
          backgroundImage: `url(${BANNER_ART})`,
          backgroundSize: "max(100%, 1920px) auto",
        }}
      />
      <div className="relative flex items-center justify-center gap-[64px] h-full max-sm:justify-start max-xs:justify-between max-xs:gap-0">
        <div className="flex items-center gap-[14px] max-sm:gap-[28px]">
          <img
            src="https://static.bigbrain.gg/assets/ugg/cta/aram-mayhem.png"
            alt=""
            className="h-[48px] w-auto shrink-0 self-end max-xs:hidden max-sm:-translate-x-1/2 max-sm:-mr-[140px]"
          />
          <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)] translate-y-[1px]">
            <div className="flex items-center gap-[6px] font-barlow-condensed font-bold text-[18px] text-white leading-none uppercase tracking-wide whitespace-nowrap">
              ARAM: MAYHEM
              <span className="flex items-center justify-center w-[32px] h-[16px] bg-[#0053FF] border border-accent-blue-400 rounded-xxs font-inter text-[10px] text-white leading-none shrink-0 normal-case tracking-normal">
                NEW
              </span>
            </div>
            <div className="font-inter font-medium text-[12px] text-white leading-[1.2] mt-[4px] whitespace-nowrap">
              Augment Tiers Directly In Game
            </div>
          </div>
        </div>
        <a
          href={href}
          onClick={onUrlClick}
          className="shrink-0 flex items-center justify-center gap-[12px] w-[150px] h-[30px] bg-accent-red-500 hover:bg-accent-red-425 rounded-sm no-underline transition-all duration-150 [filter:drop-shadow(0_4px_8px_rgba(0,0,0,0.4))]"
        >
          <SvgMiscDownload className="shrink-0 w-5 h-5 text-white" />
          <span className="font-inter font-semibold text-[13px] text-white whitespace-nowrap">Download Now</span>
        </a>
      </div>
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px]"
        style={{ background: "linear-gradient(90deg, #C3F7C7 0%, #F5CF59 34.13%, #B9F5E3 56.25%, #8062F0 76.92%, #D585F3 100%)" }}
      />
      {onClose && (
        <div
          className="absolute top-1/2 right-[8px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-80 max-xs:hidden"
          onClick={handleClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
